import { formatDate } from 'helpers';
import fp from 'lodash/fp';

export const getAction = fp.get(['activity', 'name']);

export const getCreated = fp.compose(formatDate, fp.get('created'));

export const getEmail = fp.get(['email']);
